export class AuthSync {
  constructor() {
    this.closed = false

    if (
      typeof window !== 'undefined' &&
      typeof BroadcastChannel !== 'undefined'
    ) {
      this.channel = new BroadcastChannel('auth-sync')
      this.setupListener()
    } else {
      this.channel = null
      console.warn('BroadcastChannel not available in this environment.')
    }
  }

  setupListener() {
    if (!this.channel) return

    this.channel.addEventListener('message', (event) => {
      if (event.data?.type === 'LOGOUT') {
        this.handleLogout()
      }
    })
  }

  broadcastLogout() {
    if (!this.closed && this.channel) {
      this.channel.postMessage({ type: 'LOGOUT' })
    }
  }

  handleLogout() {
    window.location.href = '/login'
  }

  close() {
    this.closed = true
    if (this.channel) {
      this.channel.close()
    }
  }
}
